import { 
  tLoginData, tSignupData,
  tUpdateActivityData, tDeleteActivityData,
  tUpdateCaseData, tAddCasesData, tDetachCasesData,
  tUpdateProfileData, 
  tForgotPassData,
  tSetNewPassData
} from "./types";
import Axios from "./Axios";

/**
 * Auth
 * 
 **/
export const auth = {
  signup: (data: tSignupData) => Axios.post("signup", data),
  login: (data: tLoginData) => Axios.post("login", data),
  logout: () => Axios.get("logout"),
  passwordReset: (data: tForgotPassData) => Axios.post("password-reset", data),
  passwordEntry: (data: tSetNewPassData) => Axios.post("password-set", data),
  ping: () => Axios.get("ping")
};

/**
 * Activity
 * 
 **/
export const activity = {
  getActivitys: (query?: string) => Axios.get(`my/activities${query}`),
  getActivityById: (id: number) => Axios.get(`my/activities/${id}`),
  updateActivities: (data: tUpdateActivityData) => Axios.patch(`my/activities/update`, data),
  deleteActivities: (data: tDeleteActivityData) => Axios.post(`my/activities/remove`, data),
};

/**
 * Case documents
 * 
 **/
export const caseDocuments = {
  getCaseDocuments: (caseId: number, query?: string) => Axios.get(`cases/${caseId}/documents${query}`),
  getCaseDocumentById: (caseId: number, documentId: number) => Axios.get(`cases/${caseId}/documents/${documentId}`),
}

/**
 * Case notices
 * 
 **/
export const caseNotices = {
  getCaseNotices: (caseId: number, query?: string) => Axios.get(`cases/${caseId}/notices${query}`),
  getCaseNoticeById: (caseId: number, noticeId: number) => Axios.get(`cases/${caseId}/notices/${noticeId}`),
}

/**
 * My Cases
 * 
 **/
export const myCases = {
  getCases: (query?: string) => Axios.get(`my/cases${query}`),
  getCaseById: (id: number) => Axios.get(`my/cases/${id}`),
  updateCase: (id: number, data: tUpdateCaseData) => Axios.patch(`my/cases/${id}`, data),
  addCases: (data: tAddCasesData) => Axios.post(`my/cases`, data),
  deleteCase: (id: number) => Axios.delete(`my/cases/${id}`),
  deleteCasesArr: (data: tDetachCasesData) => Axios.post(`my/cases/remove`, data),
}

/**
 * Profile
 * 
 **/
export const profile = {
  getProfile: () => Axios.get(`my/profile`),
  updateProfile: (data: tUpdateProfileData) => Axios.patch(`my/profile`, data),
  deleteAccount: () => Axios.delete(`my/profile`)
}

/**
 * Search
 * 
 **/
export const search = {
  all: (
    type: 'cases'|'juris'|'party-name', 
    q: string
  ) => Axios.get(`search/${type}?q=${q}`),
  docketNumber: (q: string) => Axios.get(`search/cases?q=${q}`),
  jurisCases: (q: string) => Axios.get(`search/juris?q=${q}`),
  partyCases: (q: string) => Axios.get(`search/party-name?q=${q}`)
}

/**
 * Legal Documents
 * 
 **/
export const documents = {
  getPrivacyPolicy: () => Axios.get(`documents/privacy-policy`),
  getTermsOfUse: () => Axios.get(`documents/terms-of-use`),
  saveChanges: (name: string, content: string) => Axios.patch(`admin/documents/${name}`, {content}),
};

/**
 * Admin
 * 
 **/
// users
export const adminUsers = {
  getUsers: (query?: string) => Axios.get(`admin/users${query}`),
  getUserById: (id: number) => Axios.get(`admin/users/${id}`)
}
// cases 
export const adminCases = {
  getCases: (query?: string) => Axios.get(`admin/cases${query}`),
  getCaseById: (id: number) => Axios.get(`admin/cases/${id}`),
  getUserCases: (userId: number, query?: string) => Axios.get(`admin/users/${userId}/cases${query}`),
}
// clients
export const clientsApi = {
  getClients: () => Axios.get(`admin/clients`),
  updateClient: (id: number) => Axios.patch(`admin/clients/${id}`)
}
// stats
export const adminStatsApi = {
  getStats: () => Axios.get(`admin/stats`),
}
// logs
export const adminLogs = {
  getLogs: (query?: string) => Axios.get(`admin/logs${query}`),
}
// workers
export const adminWorkers = {
  getWorkers: (query?: string) => Axios.get(`admin/workers${query}`),
  getWorkersLogs: (id: number, query?: string) => Axios.get(`admin/workers/${id}${query}`),
}